import { DOC_TYPE_PHOTO } from "../../common/constants";
import { getRegistrationDoc } from "../../common/utils/registration-utils";
import { GET_ASSOCIATE_DATA_SUCCESS, DOWNLOAD_PROFILE_PICTURE_SUCCESS, GET_ACTION_LOG_SUCCESS, SET_EDIT_MODE, CHANGE_APP_LANGUAGE } from "../action-types/profile";
import ProfileService from "../services/profile";
import DocumentService from "../services/document";

// *******************************
//  GET ASSOCIATE DATA
// *******************************

export const getAssociateData = (registrationRef) => {
    return dispatch => {
        //dispatch(setAppLoading(true));

        ProfileService.getAssociateData(registrationRef)
        .then((response) => {
            //dispatch(setAppLoading(false));
            dispatch(getAssociateDataSuccess(response));
            let profilePicture = getRegistrationDoc(response.registrationDocs, DOC_TYPE_PHOTO);
            dispatch(downloadProfilePicture(profilePicture.nodeRef));

            // get action log
            dispatch(getActionLog(response.associate.associateId));

        })
        .catch(error => {
            console.error(error);
            //dispatch(setAppLoading(false));
            //dispatch(appError("general.popup-messages.admin.get-group-list-error"));
        });
    };
}

export const getInternalAssociateData = (userRef) => {
    return dispatch => {
        //dispatch(setAppLoading(true));

        ProfileService.getInternalAssociateData(userRef)
        .then((response) => {
            //dispatch(setAppLoading(false));
            dispatch(getAssociateDataSuccess(response));
        })
        .catch(error => {
            console.error(error);
            //dispatch(setAppLoading(false));
            //dispatch(appError("general.popup-messages.admin.get-group-list-error"));
        });
    };
}

export const getAssociateDataSuccess = (associate) => {
    return  {
        type: GET_ASSOCIATE_DATA_SUCCESS,
        associate: associate
    };
}

export const getSlimAssociateData = (registrationRef) => {
    return dispatch => {
        ProfileService.getAssociateData(registrationRef)
        .then((response) => {
            dispatch(getAssociateDataSuccess(response));
        })
        .catch(error => {
            console.error(error);
        });
    };
}

// *******************************
//  DOWNLOAD PROFILE PICTURE
// *******************************

export const downloadProfilePicture = (pictureRef) => {
    return dispatch => {
        //dispatch(setAppLoading(true));

        DocumentService.downloadDocument(pictureRef)
        .then((response) => {
            //dispatch(setAppLoading(false));
            dispatch(downloadProfilePictureSuccess(response));
        })
        .catch(error => {
            //dispatch(setAppLoading(false));
            //dispatch(appError("general.popup-messages.admin.get-group-list-error"));
        });
    };
}

export const downloadProfilePictureSuccess = (picture) => {
    return  {
        type: DOWNLOAD_PROFILE_PICTURE_SUCCESS,
        profilePicture: picture
    };
}

// *******************************
//  GET ASSOCIATE ACTION LOG
// *******************************

export const getActionLog = (associateId) => {
    return dispatch => {
        //dispatch(setAppLoading(true));

        ProfileService.getAssociateActionLog(associateId)
        .then((response) => {
            //dispatch(setAppLoading(false));
            dispatch(getActionLogSuccess(response));
        })
        .catch(error => {
            //dispatch(setAppLoading(false));
            //dispatch(appError("general.popup-messages.admin.get-group-list-error"));
        });
    };
}

export const getActionLogSuccess = (response) => {
    return  {
        type: GET_ACTION_LOG_SUCCESS,
        actionLog: response.entries
    };
}


// *******************************
//  SET EDIT MODE
// *******************************
export const setEditMode = (editMode) => {
    return  {
        type: SET_EDIT_MODE,
        editMode: editMode
    };
}

// *******************************
//  CHANGE APP LANGUAGE
// *******************************
export const changeAppLanguage = (language) => {
    return  {
        type: CHANGE_APP_LANGUAGE,
        language: language
    };
}